import { HISTORY_FLOOR_LABEL } from "@shared-core/domain/customerPortalHistory";

// History reaches back to the LIVE Tharstern cutover and no further (brief
// §16 q1). A customer who has bought from us for a decade will look for 2024
// and not find it, so the floor is STATED rather than left to look like an
// empty result. Saying where the rest is turns a dead end into a route.
//
// Deliberately quiet — it is a fact about the data, not a warning.

export function PortalHistoryFloor() {
  return (
    <p className="pt-1 text-center text-xs text-muted-foreground">
      We hold orders from {HISTORY_FLOOR_LABEL} onwards here — ask us for
      anything earlier and we&apos;ll dig it out.
    </p>
  );
}
